// @ts-check
import { Content, Flex, Heading, InlineAlert, Text } from '@adobe/react-spectrum';
import React from 'react';

import BoundaryTryAgainLink from '../../../../../components/BoundaryTryAgainLink';
import { informNewRelic } from '../../../../../utils';

/**
 * @param {object} props
 * @param {boolean} [props.showTryAgainLink]
 * @param {unknown} props.error
 */
const ErrorFallback = ({ showTryAgainLink = false, error }) => {
  const errorId = informNewRelic(error);
  return (
    <Flex justifyContent="center" width="100%">
      <InlineAlert variant="notice">
        <Heading>Something went wrong while loading this publisher&apos;s apps</Heading>
        <Content>
          <Flex>
            <Text>
              Please {showTryAgainLink ? <BoundaryTryAgainLink /> : 'try again'} later
              {errorId && (
                <>
                  {' '}
                  or contact support with the following error id if the problem persists: <code>{errorId}</code>
                </>
              )}
            </Text>
          </Flex>
        </Content>
      </InlineAlert>
    </Flex>
  );
};

export default ErrorFallback;
